import React from 'react';
import { GlobeIcon, InfinityIcon, ZapIcon } from 'lucide-react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { PRICE, TOTAL_VALUE, offerRows } from '../../data/content';
export function Offer() {
  return <section id="offerta" className="w-full bg-white px-4 py-12 sm:px-6 sm:py-20" data-id="element-274" data-mp="3549da9j1r5bk">
      <div className="mx-auto max-w-3xl" data-id="element-275" data-mp="3a4xcvjlccuhe">
        <div className="text-center" data-id="element-276" data-mp="3f4a0w7ny87lk">
          <SectionLabel data-id="element-277" data-mp="3f38p20z3zh2s">L’offerta completa</SectionLabel>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-[1.15] text-navy-deep sm:text-4xl md:text-[42px]" data-id="element-278" data-mp="3jvibh710lz0b">
            Tutto ciò che ti serve per trasformare l’incertezza renale in un processo
            decisionale clinico strutturato
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-navy-deep/10 sm:mt-12" data-id="element-279" data-mp="3su3suyur37zi">
          <div className="flex items-center justify-between bg-navy-deep px-4 py-3 sm:px-6" data-id="element-280" data-mp="1nao5l0r0qq8">
            <span className="text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-white/70" data-id="element-281" data-mp="1kj3urib34tv7">
              Cosa ricevi
            </span>
            <span className="text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-white/70" data-id="element-282" data-mp="1bk0e0kze4qjv">
              Valore
            </span>
          </div>

          <ul className="divide-y divide-navy-deep/10 bg-cream" data-id="element-283" data-mp="16o1p8wa5h6ix">
            {offerRows.map(row => <li key={row.label} className="flex items-start justify-between gap-4 px-4 py-3.5 sm:px-6" data-id="element-284" data-mp="1zacq881o59g9">
                <span className="text-[13.5px] font-semibold leading-snug text-navy-deep sm:text-[15px]" data-id="element-285" data-mp="1ui35r7jbp1ld">
                  {row.label}
                </span>
                <span className="shrink-0 text-[13.5px] font-bold text-navy/60 line-through sm:text-[15px]" data-id="element-286" data-mp="2n0gumhmold8b">
                  {row.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-4 bg-white px-4 py-4 sm:px-6" data-id="element-287" data-mp="315qye4dls950">
              <span className="text-[12px] font-extrabold uppercase tracking-[0.12em] text-navy-deep" data-id="element-288" data-mp="364alw97uhszh">
                Valore totale
              </span>
              <span className="font-display text-xl font-extrabold text-navy/60 line-through sm:text-2xl" data-id="element-289" data-mp="2scnkjuz1pu9u">
                {TOTAL_VALUE}
              </span>
            </li>
          </ul>
        </div>

        <div className="mt-6 rounded-3xl border-2 border-kidney bg-navy-deep px-5 py-8 text-center sm:mt-8 sm:px-10 sm:py-10" data-id="element-290" data-mp="2idobwcea5ymu">
          <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-white/55" data-id="element-291" data-mp="29eb0vfaid200">
            Valore totale: <span className="line-through" data-id="element-292" data-mp="2dfwnhscugune">{TOTAL_VALUE}</span>
          </p>
          <p className="mt-2 text-[11px] font-extrabold uppercase tracking-[0.2em] text-kidney-bright" data-id="element-293" data-mp="2dhzas4mm49of">
            Oggi soltanto
          </p>
          <p className="mt-1 font-display text-[64px] font-extrabold leading-none text-white sm:text-[86px]" data-id="element-294" data-mp="bp1jwecebr64">
            {PRICE}
          </p>

          <div className="mx-auto mt-5 flex max-w-sm flex-col gap-1.5 text-[14px] font-semibold text-white/80" data-id="element-295" data-mp="1w6tzep8wg0pv">
            <p data-id="element-296" data-mp="1s2w46pmp3a23">
              Non pagherai {TOTAL_VALUE}. Non pagherai €97.
            </p>
            <p data-id="element-297" data-mp="25ygjlb37ta4r">
              Oggi puoi ottenere l’intero sistema Percorso Malattia Renale™ per soli{' '}
              <span className="font-extrabold text-kidney-bright" data-id="element-298" data-mp="213u714ledbj3">{PRICE}</span>.
            </p>
          </div>

          <ul className="mx-auto mt-6 grid max-w-md gap-2.5 text-left sm:grid-cols-3 sm:gap-3" data-id="element-299" data-mp="2avgrzsnjeoz1">
            {[{
            icon: ZapIcon,
            label: 'Pagamento unico'
          }, {
            icon: InfinityIcon,
            label: 'Accesso a vita'
          }, {
            icon: GlobeIcon,
            label: 'Nessun costo ricorrente'
          }].map(item => <li key={item.label} className="flex items-center gap-2 rounded-xl bg-white/[0.07] px-3 py-2.5 text-[12.5px] font-bold text-white sm:justify-center sm:text-center" data-id="element-300" data-mp="ugf8tpxiv6iz">
                <item.icon className="h-4 w-4 shrink-0 text-kidney-bright" aria-hidden="true" data-id="element-301" data-mp="rw9074xyqrw3" />
                {item.label}
              </li>)}
          </ul>

          <div className="mx-auto mt-7 max-w-md" data-id="element-302" data-mp="10vns88ts3aip">
            <CtaButton tone="cream" label="Voglio Percorso Malattia Renale™" sub={`Ottieni il sistema completo per ${PRICE} • Download immediato`} data-id="element-303" data-mp="15vijweldo44t" />
          </div>

          <div className="mt-7 rounded-2xl bg-white px-4 py-5 sm:px-6" data-id="element-304" data-mp="d8fkzlcshre1">
            <CountdownTimer data-id="element-305" data-mp="i6plmbha9k71" />
          </div>

          <div className="mt-4" data-id="element-306" data-mp="i4wbunbdijut">
            <ScarcityBar data-id="element-307" data-mp="my7jurrx96ob" />
          </div>

          <p className="mx-auto mt-5 flex max-w-sm items-start gap-2 text-left text-[12.5px] leading-snug text-white/70" data-id="element-308" data-mp="mza80rxv0v0j">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-kidney-bright" aria-hidden="true" data-id="element-309" data-mp="3lllfo1jknfgs" />
            Il cambio di valuta è automatico: pagherai nella moneta del tuo Paese al
            tasso di conversione del momento.
          </p>
        </div>
      </div>
    </section>;
}